import $ from 'jquery';
import 'slick-carousel'; 
import 'slick-carousel/slick/slick.css';
import helper from './libs/helper.js'; 

const storeLocator = {};

storeLocator.sliderLocation = function () {
	const slider = $('.store-locator .location .list');
    slider.each(function() {
        if ($(this).find('.item').length > 1) {
            $(this).slick({
                arrows: false,
                dots: false,
                speed:1000,
                infinite: false,
                slidesToShow: 1.8,
                slidesToScroll: 1
            });
        }
    })
}

storeLocator.init = function() {
	if (window.innerWidth <= 680) {
		storeLocator.sliderLocation();
	}
}

storeLocator.init();